import { render, staticRenderFns } from "./perseo_despachos.vue?vue&type=template&id=97b2a806&scoped=true"
import script from "./perseo_despachos.vue?vue&type=script&lang=js"
export * from "./perseo_despachos.vue?vue&type=script&lang=js"
import style0 from "./perseo_despachos.vue?vue&type=style&index=0&id=97b2a806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b2a806",
  null
  
)

export default component.exports